import { useEffect, useState } from 'react';
import { announceSetting, getSetting, listenToSetting, setSetting } from '../utils/settings';

// The string-valued sibling of useBooleanSetting, for preferences that pick one
// option out of several rather than flipping on and off.
const useSetting = (key, defaultValue = '') => {
  const [value, setValue] = useState(() => {
    const stored = getSetting(key);

    if (stored === undefined || stored === null) {
      // Persist the default on first run so it's explicit going forward
      if (defaultValue) setSetting(key, defaultValue);

      return defaultValue;
    }
    return stored;
  });

  // Another hook on the same key changed it
  useEffect(() => listenToSetting(key, setValue), [key]);

  const update = (newValue) => {
    setValue(newValue);
    setSetting(key, newValue);
    announceSetting(key, newValue);
  };

  return [value, update];
};

export default useSetting;
